import { Coords } from 'google-map-react';

const DEFAULT_STROKE_COLOR = '#FF0000';
const DEFAULT_FILL_COLOR = '#FF0000';
export default class MapUtils {
    static defaultZoom = 8;
    //Paris
    static defaultCenter = {
        lat: 48.864716,
        lng: 2.349014,
    };

    /**
     * Google Maps page centered on a point, to check a location at a glance
     */
    static googleMapsUrl(lat: number, lng: number): string {
        return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    }

    static extendCircleBounds(maps, bounds, latitude, longitude, radius) {
        const earthRadius = 6378.1; //Km
        const radiusKm = radius / 1000;
        const lat0 = latitude + (-radiusKm / earthRadius) * (180 / Math.PI);
        const lat1 = latitude + (radiusKm / earthRadius) * (180 / Math.PI);
        const lng0 = longitude + ((-radiusKm / earthRadius) * (180 / Math.PI)) / Math.cos((latitude * Math.PI) / 180);
        const lng1 = longitude + ((radiusKm / earthRadius) * (180 / Math.PI)) / Math.cos((latitude * Math.PI) / 180);

        const circleBounds = [
            new maps.LatLng(lat0, longitude),
            new maps.LatLng(latitude, lng0),
            new maps.LatLng(lat1, longitude),
            new maps.LatLng(latitude, lng1),
        ];
        MapUtils.extendBounds(bounds, circleBounds);
    }

    static extendBounds(bounds, polygon) {
        for (let i = 0; i < polygon.length; i++) {
            bounds.extend(polygon[i]);
        }
    }

    static getBounds(maps, polygon) {
        const bounds = new maps.LatLngBounds();

        MapUtils.extendBounds(bounds, polygon);

        return bounds;
    }

    static getPolygonCenter(maps, polygon) {
        return MapUtils.getBounds(maps, polygon).getCenter();
    }

    static generateCircle(maps, latitude, longitude, radius, strokeColor?, fillColor?, editable?, draggable?) {
        return new maps.Circle({
            center: { lat: latitude, lng: longitude },
            radius: radius,
            strokeColor: strokeColor ?? DEFAULT_STROKE_COLOR,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: fillColor ?? strokeColor ?? DEFAULT_FILL_COLOR,
            fillOpacity: 0.35,
            editable: editable ?? false,
            draggable: draggable ?? false,
        });
    }

    static generatePolygon(maps, polygon, strokeColor?, fillColor?) {
        return new maps.Polygon({
            paths: polygon,
            strokeColor: strokeColor ?? DEFAULT_STROKE_COLOR,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: fillColor ?? strokeColor ?? DEFAULT_FILL_COLOR,
            fillOpacity: 0.35,
        });
    }

    static createEditablePolygon(maps, map, coordinates, markers, onUpdatePoint: Function) {
        // console.log(coordinates);
        if (markers) {
            markers.forEach((marker) => {
                marker.setMap(null);
            });
        }

        const icon = {
            //path: google.maps.SymbolPath.CIRCLE,
            path: 'M -1 -1 L 1 -1 L 1 1 L -1 1 z',
            strokeColor: DEFAULT_STROKE_COLOR,
            strokeOpacity: 0,
            fillColor: DEFAULT_FILL_COLOR,
            fillOpacity: 1,
            scale: 5,
        };

        const polygon = new maps.Polygon({
            map: map,
            paths: coordinates,
            strokeColor: DEFAULT_STROKE_COLOR,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: DEFAULT_FILL_COLOR,
            fillOpacity: 0.5,
            zIndex: -1,
        });

        const marker_options: any = {
            map: map,
            icon: icon,
            flat: true,
            draggable: true,
            raiseOnDrag: false,
        };

        for (let i = 0; i < coordinates.length; i++) {
            marker_options.position = coordinates[i];
            const point = new maps.Marker(marker_options);
            markers.push(point);

            maps.event.addListener(point, 'drag', update_polygon_closure(polygon, i));
            maps.event.addListener(point, 'dragend', update_end_polygon_closure());
        }

        function update_polygon_closure(polygon, i) {
            return function (event) {
                polygon.getPath().setAt(i, event.latLng);
                coordinates[i] = { lat: event.latLng.lat(), lng: event.latLng.lng() };
            };
        }

        function update_end_polygon_closure() {
            return function (event) {
                if (onUpdatePoint) {
                    onUpdatePoint();
                }
            };
        }
        return polygon;
    }

    static addMarker(maps, map, position, title = 'Marker', label = 'M') {
        if (maps) {
            return new maps.Marker({
                position,
                title,
                label,
                map,
            });
        }
    }

    static removeMarker(marker) {
        if (marker) {
            marker.setMap(null);
        }
    }

    static checkLocation(location: Coords): boolean {
        const { lat, lng } = location;
        let valid = true;
        if (lat < -90 || lat > 90) {
            valid = false;
        }
        if (lng < -180 || lng > 180) {
            valid = false;
        }
        if (!valid) {
            // console.log(`Location invalide => lat:${lat}, lng:${lng}`);
        }
        return valid;
    }
}
